export enum ActionTypes {
    CHANGE_ME = 'CHANGE_ME',
}



// WEBPACK FOOTER //
// ./src/types/action-types.ts